import React from 'react'
import {FormattedMessage, useIntl} from 'react-intl'
import {Card, SectionHeading} from '../../components/PageLayout'
import {QuestionList} from '../../components/QuestionList'
import {
  BIOPSY_FACILITIES,
  HOSPITALS,
  PHYSICIAN_OR_PROVIDER,
  SCAN_FACILITIES,
  OTHER_FACILITIES
} from '../../enums/MedicalRecordLocationType'
import {OtherFacilities} from '../forms/OtherFacilities'
import {EmptyLocationRecordText} from '../MedicalRecords'
import styled from 'styled-components'
import { INSTITUTION, UPLOAD } from '../../enums/UploaderManagement'

export const PROVIDERS_LABELS = (intl) => ({
  [PHYSICIAN_OR_PROVIDER]: intl.formatMessage({
    defaultMessage: "Physicians",
    description: "Medical record location form, institution type, physician label"
  }),
  [HOSPITALS]: intl.formatMessage({
    defaultMessage: "Hospitals",
    description: "Medical record location form, institution type, hospital label"
  }),
  [SCAN_FACILITIES]: intl.formatMessage({
    defaultMessage: "Scan Facilities",
    description: "Medical record location form, institution type, scan facility label"
  }),
  [BIOPSY_FACILITIES]: intl.formatMessage({
    defaultMessage: "Biopsy Facilities",
    description: "Medical record location form, institution type, biopsy facility label"
  }),
  [OTHER_FACILITIES]: intl.formatMessage({
    defaultMessage: "Facilities",
    description: "Medical record location form, institution type, facility label"
  })
})
export const PROVIDERS_OPTIONS = (intl) => Object.keys(PROVIDERS_LABELS(intl))

const MedicalRecordLocationFormContainer = styled.div`
  h4 span {
    font-weight: 400;
    color: rgba(0,0,0,0.4);
  }
`

const emptyRecordLocation = () =>
  <EmptyLocationRecordText>No medical records location details provided.</EmptyLocationRecordText>

export const MEDICAL_RELEASE_PATH = ["records"]

export const ReleaseLocationForms = ({readOnly,form,locationRef,step, mode, toggle}) => {
  const intl = useIntl()
  return <>
    {step !== INSTITUTION &&
      <SectionHeading ref={locationRef}>
        <p><FormattedMessage defaultMessage="Identify location of prior records, and complete release below." description="ReleaseLocationForms subtitle"/></p>
      </SectionHeading>
    }
    
      <MedicalRecordLocationFormContainer>
        <Card css={mode === UPLOAD ? "padding: 0; border: 0px;" : "" }>
          <QuestionList
            // filter={_.filter(_.matchesProperty('locationType', OTHER_FACILITIES))}
            getEmpty={() => ({ id: Date.now(), 'locationType': OTHER_FACILITIES })}
            disabled={readOnly}
            whenEmpty={readOnly && emptyRecordLocation()}
            path={MEDICAL_RELEASE_PATH.join("")}
            addLabel={intl.formatMessage({
              defaultMessage: "Add facility",
              description: "Medical record location form, add facility button"
            })}
            step={step ? step : INSTITUTION}
          >{(otherFacility, i) =>
            <OtherFacilities
              disabled={readOnly}
              i={i}
              key={otherFacility.id}
              form={form}
              path={MEDICAL_RELEASE_PATH}
              toggle={toggle}
            />
            }
          </QuestionList>
        </Card>
        
      </MedicalRecordLocationFormContainer>
    
  </>
}
